import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import WifiIcon from "components/Icons/TobarIcons/WifiIcon";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectCurrentDeviceStatusSettings } from "stores/auth/authSlice";
import { selectColorThemeMode } from "stores/ui/uiSlice";

// SSIDs from the agent can contain stray `%` characters that aren't valid
// `%XX` escapes (e.g. "100% Wifi", truncated encoding, non-UTF-8 bytes).
// decodeURIComponent throws URIError("URI malformed") on these — the
// .replace(/%/g, '') on the next line is meant to strip them but only runs
// after decoding succeeds, so we need a try/catch first. On failure, fall
// back to the raw string; the strip-% replace below cleans it up.
const safeDecode = (s) => {
  if (typeof s !== "string") return s;
  try { return decodeURIComponent(s); } catch { return s; }
};

const WifiIconDropDown = () => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const currentDeviceStatusSettings = useAppSelector(selectCurrentDeviceStatusSettings);

  const WIFIICON_DROPDOWN_DATA = Object.keys(currentDeviceStatusSettings?.device_status || {})
    .filter(key => key.startsWith('ap'))
    .map(key => {
      const value = safeDecode(currentDeviceStatusSettings?.device_status[key]);
      return value && value !== "<unknown ssid>" ? value.replace(/%/g, '').replace(/\+/g, ' ') : null;
    }).filter(value => value !== null);

  return (
    <>
      <Menu
        matchWidth
        isLazy
        lazyBehavior="unmount"
        mb={{ sm: "10px", md: "20px", base: "10px" }}
        p={"10px 0px"}
        h="100%"
        closeOnSelect={false}
      >
        <MenuButton
          as={Button}
          w={{ base: "full", md: "50px" }}
          p={0}
          minW={"0px"}
          h={"50px"}
          borderRadius={"0px"}
          _hover={{ bg: "#00000020" }}
        >
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            gap="1"
          >
            <WifiIcon />
          </Box>
        </MenuButton>
        <MenuList
          zIndex={1002}
          overflow="hidden"
          right={{ base: "-30px", md: "0px" }}
          position={"absolute"}
          minW={{ base: "100px", md: "150px !important" }}
          maxW={{ base: "100px", md: "150px !important" }}
          borderRadius={"4px"}
          marginTop={"-9px"}
          p={0}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          {WIFIICON_DROPDOWN_DATA &&
            WIFIICON_DROPDOWN_DATA.map((item,index) => {
              return (
                <MenuItem
                  key={index}
                  as={Box}
                  h="50px"
                  bgColor={`${colorThemeMode}_background`}
                  color={`${colorThemeMode}_text`}
                  borderTop={"1px solid"}
                  borderTopColor={`${colorThemeMode}_tertiary`}
                  _hover={{
                    color: `${colorThemeMode}_primary`,
                    bgColor: `${colorThemeMode}_tertiary`,
                  }}
                >
                  <Text fontSize={"16px"} fontWeight={"400"}>
                    {item}
                  </Text>
                </MenuItem>
              );
            })}
        </MenuList>
      </Menu>
    </>
  );
};

export default WifiIconDropDown;
